export class MeeTopicAnswerModel{
    id:number;
    title:string;
    detail:string;
    description:string;
    type:string;
    answer:string;

    constructor(){}
}